// @format
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import searchBg from './page2image.png';
import searchBgMobile from './page2image-mobile.png';
import './SearchIntro.css';
import PhoneWithPhoto from 'modules/components/PhoneWithPhoto';
import MatchMedia from 'modules/components/MatchMedia';

const SearchIntro = ({ className }) => (
  <section className={classnames('SearchIntro', className)}>
    <p className="SearchIntro-title">Effectively Meet a Person</p>
    <div className="SearchIntro-search">
      <p className="SearchIntro-search-left">Detect Faces and Identify</p>
      <MatchMedia mediaQueries="(min-width: 1149px)">
        {isMatched => (
          <VisibilitySensor partialVisibility={true} offset={{ top: 200 }}>
            {({ isVisible }) => (
              <PhoneWithPhoto
                className={classnames('SearchIntro-search-phone', {
                  'element-enter': isVisible,
                })}
                contentUrl={isMatched ? searchBg : searchBgMobile}
              >
                <div className="SearchIntro-Phone-content-detect" />
                <div className="SearchIntro-Phone-content-detected" />
                <div className="SearchIntro-Phone-content-result" />
              </PhoneWithPhoto>
            )}
          </VisibilitySensor>
        )}
      </MatchMedia>
      <p className="SearchIntro-search-right">
        The cutting edge face recognition will detect the faces automatically,
        then search and get results from database.
      </p>
    </div>
  </section>
);

SearchIntro.propType = {
  className: PropTypes.string,
};

export default SearchIntro;



// WEBPACK FOOTER //
// ./src/modules/components/SearchIntro/SearchIntro.js